import linked_img from "../../Image/cert_logos/web.jfif";
import data from "../../Image/cert_logos/data.png";
import gc_img from "../../Image/cert_logos/cloud.jfif";
import tcs_img from "../../Image/cert_logos/tcs_img.png";
import unstop_img from "../../Image/cert_logos/hackerrank.png";
import sololearn_img from "../../Image/cert_logos/business.png";

const my_certificates_data = [
  {
    index: 1,
    cert_title_name: "Python",
    cert_provider_name: "Udemy Business",
    cert_provider_img_link: tcs_img,
    cert_time_stamp: "Dec 2022",
    back_grd_color: "#aaf5ff",
    cert_pdf_link:
      "https://drive.google.com/file/d/1U9Hfd_e6slJ9PF9Uu3hT29oZ92CFy1GF/view?usp=share_link",
  },
  {
    index: 2,
    cert_title_name: "Cloud Computing",
    cert_provider_name: "Udemy",
    cert_provider_img_link: gc_img,
    cert_time_stamp: "Jan 2023",
    back_grd_color: "#fff176",
    cert_pdf_link:
      "https://drive.google.com/file/d/112uhykVNvYnKELsFgFh6fKeZmHLfTv0D/view?usp=share_link",
  },
  {
    index: 3,
    cert_title_name: "Hackerrank",
    cert_provider_name: "Hackerrank",
    cert_provider_img_link: unstop_img,
    cert_time_stamp: "Feb 2023",
    back_grd_color: "#d1b7ff",
    cert_pdf_link:
      "https://www.hackerrank.com/certificates/fe80c2ab9a49",
  },
  {
    index: 4,
    cert_title_name: "Business Ettiquete",
    cert_provider_name: "Kara Ronin",
    cert_provider_img_link: sololearn_img,
    cert_time_stamp: "Jan 2023",
    back_grd_color: "#aaf5ff",
    cert_pdf_link: "https://drive.google.com/file/d/103Z9XD89KWbRMNqQ0S62LrKT7A5pNwij/view?usp=share_link",
  },
  {
    index: 5,
    cert_title_name: "Data Structures",
    cert_provider_name: "Vinoth",
    cert_provider_img_link: data,
    cert_time_stamp: "Mar 2023",
    back_grd_color: "#ffd7ca",
    cert_pdf_link:
      "https://drive.google.com/file/d/12ffqpNKYc0HDhquHQvK9mzi9Jc4EldLQ/view?usp=share_link",
  },
  {
    index: 6,
    cert_title_name: "Web Development",
    cert_provider_name: "Udemy",
    cert_provider_img_link: linked_img,
    cert_time_stamp: "April 2023",
    back_grd_color: "#ffd7ca",
    cert_pdf_link:
      "https://drive.google.com/file/d/1i9FBKiXMRrBqn4kfdfkIGf2H3CHuoWAM/view?usp=share_link",
  },
  
];

export default my_certificates_data;
